export const NavBarNames = {
  customer: 'Customer',
  segments: 'Segments',
  customerGroup: 'Customer Lists',
  levels: 'Levels',
  records: 'Records',
  campaigns: 'Campaigns',
  stampCampaigns: 'Stamp Campaigns',
  events: 'Events',
  campaignCategory: 'Campaign Categories',
  message: 'Messages',
  earnRules: 'Earning Rules',
  coupons: 'Coupon Sets',
  tickets: 'Ticket Sets',
  giftCards: 'Gift Cards',
  giftCardRecords: 'Gift Card Records',
  rewards: 'Rewards',
  mall: 'Mall',
  brands: 'Brands',
  stores: 'Stores',
  storeCodes: 'Store Code List',
  storeCategory: 'Store Categories',
  translations: 'Translations',
  transactions: 'Transactions',
  bulkRewards: 'Bulk rewards update',
  stampRecords: 'Stamp records',
  pointRecords: 'Point Records',
  couponRecords: 'Coupon Records',
  ticketRecords: 'Ticket Records',
  others: 'Webview content',
  admin: 'Users',
  adminGroup: 'Permission Groups',
  dashboard: 'Dashboard',
  metricTable: 'Metric Table',
  dashboardCampaignAndRedemption: 'Campaigns/Redeem',
  dashboardDemographic: 'Demographics',
  dashboardSales: 'Sales',
  banners: 'Banners',
  productCategory: 'Product categories',
  featuredCampaign: 'Featured Campaigns',
  featuredProduct: 'Featured products',
  langauge: 'Languages',
  levelDiscount: 'Level Benefits',
  webview: 'Webview content',
  rfm: 'RFM',
  messageCreditRecords: 'Message Credit Records',
  appUpdate: 'App Update',
  maintenance: 'Maintenance',
};
